import * as service from './service'
export default {
  namespace: 'recommendMessengerRecommendList',
  state: {
    demoData: {}
  },
  effects: {
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
